import $ from 'jquery';
import {POST} from './fetch.ts';

type ResolveConversationOpts = {
  url: string;
  commentId: string;
  origin: string;
  action: string;
  conversationHolder: Element;
};

/**
 * Resolves or unresolves a conversation by calling the update endpoint and
 * replacing the conversation holder DOM with the server response. Returns the
 * new jQuery-wrapped conversation element, or null on failure.
 */
export async function resolveConversation(opts: ResolveConversationOpts): Promise<JQuery | null> {
  try {
    const response = await POST(opts.url, {
      data: new URLSearchParams({
        origin: opts.origin,
        action: opts.action,
        comment_id: opts.commentId,
      }),
    });
    const data = await response.text();

    const $conversation = $(data);
    $(opts.conversationHolder).replaceWith($conversation);
    $conversation.find('.dropdown').dropdown();
    return $conversation;
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
}
